import React from 'react';
import Icon from 'src/components/Icon';

export default function AccordionList({ list }: { list: string[][] }): JSX.Element {
  const [openArray, setOpenArray] = React.useState<number[]>([]);
  const openRow = (index: number, isOpen: boolean) => {
    const newArray = new Array(list.length).fill(0);
    newArray[index] = isOpen ? 0 : 1; // toggle
    setOpenArray(newArray);
  };

  React.useEffect(() => {
    const newArray = new Array(list.length).fill(0);
    // defaultArray[0] = 1;
    setOpenArray(newArray);
  }, [list]);
  return (
    <div className="accordion-list">
      {list &&
        list.map((item: string[], index: number) => {
          return (
            <div key={index} className="-mx-6">
              <div className="">
                {/* 타이틀 */}
                <div
                  className={`relative pt-5 pb-5 pl-6 pr-16 flex items-start border-t border-ice-blue cursor-pointer ${
                    openArray[index] !== 1 ? '' : 'border-b'
                  }`}
                  onClick={() => {
                    openRow(index, openArray[index] === 1);
                  }}
                >
                  <div className="N_16_M text-bluey-purple ">Q</div>
                  <div className="N_14_R text-black ml-3">{item[1]}</div>
                  <div className="absolute top-6 right-6">
                    <Icon name="down" size="20" />
                  </div>
                </div>
                {/* 내용 */}
                <div className={`bg-light-gray-1 pt-5 pb-5 px-6 flex items-start ${openArray[index] === 1 ? 'block' : 'hidden'}`}>
                  <div className="N_16_M text-black">A</div>
                  <div className="N_14_R text-brown-grey ml-3 break-words">{item[2]}</div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
}
